import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import pure from 'recompose/pure';
import { translate } from 'admin-on-rest';

const TextField = ({ source, record = {}, elStyle, translate }) => {
    return get(record, source) ? 
    <span style={elStyle}>{get(record, source)}</span>
    : <span style={{textTransform: "uppercase"}}>{translate("resources.storeMessages.deletedStore")}</span>
};

TextField.propTypes = {
    addLabel: PropTypes.bool,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const PureTextField = pure(TextField);

PureTextField.defaultProps = {
    addLabel: true,
};

export default translate(PureTextField);



// WEBPACK FOOTER //
// ./src/components/CRM/TextFieldStoreMessage.js